export default __webpack_public_path__ + "static/media/2073.ed33cc2f.png";